import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routerList = [
    {
        path: '/',
        component: () => import( '../../pages/Passport.vue'),
        name:'passport',
        meta: {title: '登录'},
    },
	{
	    path: '/404',
	    component: () => import( '../../pages/404.vue'),
	    name:'nodata404',
	    meta: {title: '抱歉您找的页面失踪了'},
	},
	{
	    path: '/expire',
	    component: () => import( '../../pages/expire.vue'),
	    name:'expire',
	    meta: {title: '店铺过期了'},
	},
	{
	    path: '/refresh',
	    component: () => import( '../../pages/Refresh.vue'),
	    name:'refresh',
	    meta: {title: '刷新页面'},
	},
	
	{
		path: '/loyout',
		component: () => import( '../../pages/Layout.vue'),
		name:'layout',
		meta: {title: '布局图'},
		children:[
			{
			    path: '/mendian',
			    component: () => import( '../../pages/Mendian.vue'),
			    name:'mendian',
			    meta: {title: '店铺列表'},
			},
			{
			    path: '/mendian/create',
			    component: () => import( '../../pages/CreateMendian.vue'),
			    name:'mendian_create',
			    meta: {title: '创建店铺'},
			},
		]
	}
];







const routerObj = new VueRouter({
    routes:routerList
});

//console.log(routerList);

routerObj.beforeEach((to, from, next) => { 
     if(to.name == null){
        next({
            path:'/404'
        });
     }else{
       document.title =  to.meta.title
       next();
     }
})

export default routerObj;